export default "__VITE_ASSET__ymfOXq23__"